import React from "react";
import { Button } from "antd";
import { openNewTab } from "../../providers/utils/openLink";
import {
  retrieveRefreshToken,
  retrieveToken,
} from "../../libs/sgx/api/tokenStorage";

const PRODUCCION_WEBAPP_ROOT_URL = "/front-end";

const DEVELOP_WEBAPP_ROOT_URL = "http://localhost:3005/recetas/token";

const isProduction = () => process.env.NODE_ENV === "production";

const rootUrl = () =>
  isProduction()
    ? PRODUCCION_WEBAPP_ROOT_URL
    : `${DEVELOP_WEBAPP_ROOT_URL}/${retrieveToken()}/${retrieveRefreshToken()}`;

const AuditarRecetas = () => (
  <Button onClick={() => openNewTab(rootUrl())}>Ir a recetas</Button>
);

export default AuditarRecetas;
